module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"settings":"Settings","users":"Users","products":"Products"},"pt-BR":{"settings":"Configurações","users":"Usuários","products":"Produtos"}}')
  delete Component.options._Ctor
}
